import React, { useCallback, useEffect, useState } from 'react'
import { reqGet, TOneItemCallback } from 'HttpRequests'
import PasswordInput from 'components/inputs/PasswordInput'
import EmptyLink from 'components/EmptyLink'
import { Form } from 'react-bootstrap'
import LoadingBlueButton from 'components/inputs/LoadingBlueButton'
import LoginPhoneInputWrap from 'auth/login_dialog/LoginPhoneInputWrap'
import CaptchaInput from 'components/inputs/CaptchaInput'

interface ILoginingFormProps {
  loginPhone: string
  isLoading: boolean
  onChangeLoginPhone: TOneItemCallback<string>
  password: string
  onChangePassword: TOneItemCallback<string>
  onLogin: (login: string, password: string, isRemember: boolean, captcha: string,
    captchaHash: string) => void
  onGoToRegister: VoidFunction
  onGoToRecovery: VoidFunction
  onSetMessage: TOneItemCallback<string>
  showCaptcha: boolean
}

const LoginForm: React.FC<ILoginingFormProps> = ({
  loginPhone,
  isLoading,
  onChangeLoginPhone,
  password,
  onChangePassword,
  onLogin,
  onGoToRegister,
  onGoToRecovery,
  onSetMessage,
  showCaptcha,
}) => {
  const [passwordError, setPasswordError] = useState<string>('')
  const [isRemember, setIsRemember] = useState(false)
  const [captcha, setCaptcha] = useState('')
  const [captchaImg, setCaptchaImg] = useState('')
  const [captchaHash, setCaptchaHash] = useState('')

  const handleChangePassword = useCallback(
    (value, isValid) => {
      if (isValid) onChangePassword(value)
      else onChangePassword('')
    },
    [onChangePassword]
  )

  useEffect(() => {
    if (!password) setPasswordError('Введите пароль')
    else setPasswordError('')
  }, [password])

  useEffect(() => {
    if (showCaptcha) {
      reqGet("/api/captcha/", (resp) => {
        setCaptchaImg(resp.img)
        setCaptchaHash(resp.hash)
      })
    }
  }, [showCaptcha])

  const handleCheckRemember = (event: React.ChangeEvent<HTMLInputElement>) => {
    setIsRemember(event.target.checked)
  }

  const handleLoginClick = useCallback(() => {
    onSetMessage('')
    if (loginPhone.length === 0 || password.length === 0 || (showCaptcha && captcha.length < 6)) {
      onSetMessage('Заполните поля')
    } else {
      onLogin(loginPhone, password, isRemember, captcha, captchaHash)
      reqGet("/api/captcha/", (resp) => {
        setCaptchaImg(resp.img)
        setCaptchaHash(resp.hash)
        setCaptcha('')
      })
      // reqLogin(phoneNumber, password, (response) => {
      //   if (response.status === 'OK' && response.token) {
      //     onLogin(response.token, isRemember)
      //   } else {
      //     setError('Неверный телефон или пароль')
      //   }
      // })
    }
  }, [loginPhone, password, isRemember, captcha, captchaHash, onSetMessage, onLogin, showCaptcha])

  return (
    <div>
      <p>Пожалуйста, авторизуйтесь</p>
      <LoginPhoneInputWrap
        isRequired
        value={loginPhone}
        onlyPhone
        onChange={() => {}}
        onEntered={onChangeLoginPhone}
        style={{ width: '100%' }}
      />
      <div className='m-2'></div>

      <PasswordInput
        required
        value={password}
        errorMessage={passwordError}
        placeholder='пароль'
        onChange={handleChangePassword}
        onEntered={handleLoginClick}
        maxLength={20}
        minLength={1}
        style={{ width: '100%' }}
      />
      <div className='m-2'></div>

      {showCaptcha ? <div><input type="hidden" value={captchaHash} />
        <img src={"data:image/jpeg;base64, " + captchaImg} alt="Captcha" />
        <CaptchaInput value={captcha} onChange={setCaptcha} /><div className='m-2'></div></div>
      : ''}

      <div style={{ marginBottom: '1rem' }}>
        <LoadingBlueButton
          onClick={handleLoginClick}
          isLoading={isLoading}
          style={{ width: '100%' }}
        >
          Войти
        </LoadingBlueButton>
      </div>
      <div className='m-2' />

      <Form.Check type='checkbox' label='Запомнить меня' onChange={handleCheckRemember} />

      <EmptyLink onClick={onGoToRegister}>
        Нет учетной записи? Зарегистрироваться!
      </EmptyLink>

      <div style={{ marginTop: '1rem' }}>
        <EmptyLink onClick={onGoToRecovery}>Забыли пароль?</EmptyLink>
      </div>
      
    </div>
  )
}
export default LoginForm
